/**
 * @generated SignedSource<<95effc24109930b11ba53302a5b39cb4>>
 * @relayHash 248f3563100d8e15d35ae1e799026f3a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1c7d99bab9d9948fc8fb205c9c699a3cf408692c2d65b91ab0d6dc50848cc895

import type { ConcreteRequest, Query } from 'relay-runtime';
export type contentAppearanceQuery$variables = {
  contentId?: string | null | undefined;
  status?: ReadonlyArray<string | null | undefined> | null | undefined;
};
export type contentAppearanceQuery$data = {
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly appearanceDraft: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null | undefined;
          readonly key: string | null | undefined;
          readonly value: string | null | undefined;
          readonly version: {
            readonly number: number | null | undefined;
          } | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly id: string | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type contentAppearanceQuery = {
  response: contentAppearanceQuery$data;
  variables: contentAppearanceQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "status"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      },
      {
        "kind": "Variable",
        "name": "status",
        "variableName": "status"
      }
    ],
    "concreteType": "PaginatedContentListWithChild",
    "kind": "LinkedField",
    "name": "content",
    "plural": false,
    "selections": [
      {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "alias": "appearanceDraft",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "content-appearance-draft"
              }
            ],
            "concreteType": "PaginatedJsonContentPropertyList",
            "kind": "LinkedField",
            "name": "properties",
            "plural": false,
            "selections": [
              {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "key"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "value"
                  },
                  {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "number"
                      }
                    ]
                  }
                ]
              }
            ],
            "storageKey": "properties(key:\"content-appearance-draft\")"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "contentAppearanceQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "contentAppearanceQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "248f3563100d8e15d35ae1e799026f3a",
    "id": "1c7d99bab9d9948fc8fb205c9c699a3cf408692c2d65b91ab0d6dc50848cc895",
    "metadata": {},
    "name": "contentAppearanceQuery",
    "operationKind": "query",
    "text": "query contentAppearanceQuery($contentId:ID,$status:[String]){content(id:$contentId,status:$status){nodes{id,appearanceDraft:properties(key:\"content-appearance-draft\"){nodes{id,key,value,version{number}}}}}}"
  }
};
})();

(node as any).hash = "2759a808b8b28292d06027462e1ddc0f";

export default node;
